import Component from 'gia/Component'

import Observer from '../components/observer';



class Fyi extends Component {

  constructor(element) {

    super(element)

    this.body = document.body
    this.element = element
   // this.i = 0


    this.ref = {
      container: null
    }

  }

  mount() {



this.observer = new Observer({
  rootMargin: '20% 0% -5% 0%'
});
this.observer.add([this.ref.container]);
   

    }    



    resize(){

       


       

    }

    unmount() {



    }

}

module.exports = Fyi



